import { nameIdType } from "src/components/atoms/AutocompleteWithAdd";

export const tagModifier = (tag: string | nameIdType | null) => {
  if (!tag) return "";
  return typeof tag === "string"
    ? tag
    : tag.name.replaceAll('"', "").replace("Add ", "");
};
